// export const SERVER_URL = "http://localhost:5000";

//export const SERVER_URL = "https://backend-r8cp.onrender.com/";
export const SERVER_URL = "https://englishproductionbackend.onrender.com/";
